import React, { useState, useEffect, useRef } from 'react';
import {
    Container,
    TextField,
    Button,
    FormControl,
    Typography,
    Autocomplete,
    InputAdornment
} from '@mui/material';
import Barcode from 'react-barcode';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search'; // Importing Search icon

function BarcodeGenerator() {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null); // Changed to null to work with Autocomplete
    const [quantity, setQuantity] = useState(1);
    const [barcodes, setBarcodes] = useState([]);
    const [searchBarcode, setSearchBarcode] = useState(''); // State to handle search by barcode

    const componentRef = useRef();

    // Fetch product data from the API when the component mounts
    useEffect(() => {
        axios.get('https://serveralgama.mylksystems.com/Item/getItemDetails')
            .then(res => { setProducts(res.data); })
            .catch(error => console.error('Error fetching product data:', error));
    }, []);

    // Generate barcodes based on the selected product and quantity
    const handleGenerate = () => {
        const barcodeList = [];
        for (let i = 0; i < quantity; i++) {
            barcodeList.push(selectedProduct);
        }
        setBarcodes(barcodeList);
    };

    // Handle the print action
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Barcodes'
    });

    // Handle the search by barcode functionality
    const handleBarcodeSearch = (event) => {
        setSearchBarcode(event.target.value);
    };

    // Filter products based on barcode search
    const filteredProducts = products.filter(product =>
        product.ItemID.toString().includes(searchBarcode) || // Match the barcode
        product.ItemName.toLowerCase().includes(searchBarcode.toLowerCase()) // Optionally match item name
    );

    return (
        <Container maxWidth="sm" style={{ marginTop: '0em', paddingTop: '10em' }}>
            <Typography variant="h4" gutterBottom>
                Algama Products Barcode Generator
            </Typography>
            

            {/* Searchable Dropdown using Autocomplete */}
            <Autocomplete
                value={selectedProduct}
                onChange={(event, newValue) => setSelectedProduct(newValue)} // Sets the selected product
                disablePortal
                id="product-search"
                options={filteredProducts} // Use filtered products based on barcode search
                getOptionLabel={(option) => option.ItemName} // Displays the product name in the dropdown
                isOptionEqualToValue={(option, value) => option.ItemID === value.ItemID} // Ensures the selected option is valid
                renderInput={(params) => <TextField {...params} label="Select Product" fullWidth />}
                style={{ marginBottom: '1em' }}
            />



            <TextField
                type="number"
                label="Number of Barcodes"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                fullWidth
                style={{ marginBottom: '1em' }}
                inputProps={{ min: 1 }}
            />

<div
    style={{
        display: 'flex',
        justifyContent: 'center', // Center horizontally
    }}
>
    <div>
        <Button
            variant="contained"
            color="primary"
            onClick={handleGenerate}
            style={{ marginRight: '1em' }}
            disabled={!selectedProduct}
        >
            Generate
        </Button>
        <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            disabled={barcodes.length === 0}
        >
            Print
        </Button>
    </div>
</div>


            {/* Display generated barcodes */}
            {barcodes.length > 0 && (
    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
        <div
            ref={componentRef}
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(5, 1fr)', // Create 4 equal columns
                gap: '10px', // Adjust gap between items
                alignItems: 'center',
                justifyItems: 'center',
                marginTop: '0em',
            }}
        >
            {barcodes.map((code, index) => (
                <div
                    key={index}
                    className="barcode-container"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginTop: '10px',
                        width: 'auto', // Let the container adjust to content
                        padding: '5px', // Add padding around the barcode content
                    }}
                >
                    <Barcode
                        value={code.ItemID.toString()}
                        width={1.2} // Fixed width for the bars
                        height={45} // Fixed height for the barcode
                        format="CODE128"
                        displayValue={true}
                        fontSize={10}
                        margin={0}
                        renderer="svg"
                        style={{ maxWidth: '100%' }} // Make sure barcode doesn’t overflow
                    />
                    <p
                        style={{
                            marginTop: '5px',
                            fontSize: '8px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        {code.ItemName} 
                    </p>
                    <p
                        style={{
                            marginTop: '1px',
                            fontSize: '16px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        Rs.{code.sellingPrice} 
                    </p>
                </div>
            ))}
        </div>
    </div>
)}

        </Container>
    );
}

export default BarcodeGenerator;
